import React, { FunctionComponent, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import SvgDecoration from '../generated/svg/decoration'
import { useBreakpoint } from '../hooks/use-breakpoint'
import { isInvalidDate } from '../utils/type-check'
import { AutoImage } from './auto-image'

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media (max-width: 40rem){
    gap: 4rem;
  }
`

const Inner = styled.div`
  &:first-child {
    @media (max-width: 40rem){
      order: 1;
    }
  }
`

const Header = styled.div`
  display: flex;
  margin-bottom: 1rem;
  align-items: flex-end;
  @media (max-width: 40rem){
    margin-bottom: 2rem;
  }
`

const DecorationContainer = styled.div`
  margin-right: 0.75rem;
  @media (max-width: 40rem){
    margin-right: 0;    
  }
  svg {
    display: block;
    height: 1rem;
  }
  img {
    height: 2rem;
  }
`

const Label = styled.div`
  font-weight: 700;
  @media (max-width: 40rem){
    font-size: 1.25rem;
  }
`

const ItemContainer = styled.div`
  @media (max-width: 40rem){
    display: flex;
    flex-wrap: wrap;
    gap: 1rem 0;
  }
`

const Item = styled(Link)`
  padding: 0.5rem 0;
  display: block;
  box-sizing: border-box;
  @media (max-width: 40rem){
    flex: 1 1 50%;
  }
  &:hover {
    text-decoration: underline;
  }
`

type SideBarProps = {
  archiveMap: Map<number, number> // time, count
  categoryMap?: Map<string, ReactNode> // to, label
  urlGenerator: (time: number) => string
}
export const SideBar: FunctionComponent<SideBarProps> = ({archiveMap, categoryMap, urlGenerator}) => {
  const isMobile = useBreakpoint('40rem')
  return <Outer>
    {
      categoryMap &&
      <Inner>
        <Header>
          <DecorationContainer>
            {
              isMobile ?
              <AutoImage src="/images/m_02.png" /> :
              <SvgDecoration />  
            }
          </DecorationContainer>
          <Label>
            CATEGORY
          </Label>
        </Header>
        <ItemContainer>
          {
            Array.from(categoryMap).map(([to, label]) => {
              return <Item key={to} to={to} style={{flex: '0 0 100%'}}>
                -{label}
              </Item>
            })
          }
        </ItemContainer>
      </Inner>
    }
    <Inner>
      <Header>
        <DecorationContainer>
            {
              isMobile ?
              <AutoImage src="/images/m_01.png" /> :
              <SvgDecoration />  
            }
        </DecorationContainer>
        <Label>
          ARCHIVE
        </Label>
      </Header>
      <ItemContainer>
        {
          Array.from(archiveMap).sort(([a], [b]) => b - a).map(([time, count]) => {
            return <Item key={time} to={urlGenerator(time)}>
              -{formatDate(new Date(time))} ({count})
            </Item>
          })
        }
      </ItemContainer>
    </Inner>
  </Outer>
}

const formatDate = (date: Date) => {
  if(isInvalidDate(date)) return '----年-月'
  return `${date.getFullYear()}年${date.getMonth() + 1}月`
}